import { ref } from 'vue'
import Api from "../Api"
import Image from "@/services/Image"

export function useUsers() {
    const formattedUsers = ref([])
    const isLoading = ref(false)

    const formatElement = (item) => {
        let value = item["user_id"] ?? 0
        let name = item["user_name"] ?? ""
        let hasImage = item["user_avatar_host"] && item["user_avatar_name"]

        if (value === 0 || name === "") {
            return []
        }

        return [{
            value,
            name,
            image: hasImage ? Image.handle(item["user_avatar_host"], item["user_avatar_name"], 60, 60) : null
        }]
    }

    const fetchUsers = async () => {
        isLoading.value = true

        try {
            // todo должна быть первоначальная загрузка а затем уже фильтрация при поиске
            const items = await Api.users(1000)
            formattedUsers.value = Object.values(items).flatMap(formatElement)
        } catch (error) {
            console.error("Не удалось загрузить список пользователей:", error)
        } finally {
            isLoading.value = false
        }
    }

    return {
        formattedUsers,
        isLoading,
        fetchUsers
    }
}
